import { mapObjectKeysToValues } from '../../utils/core/object';

export const OBLIGATION_STATUSES = {
    PUBLISHED: 'Published',
    DRAFT: 'Draft',
    AWAITING_REVIEW: 'Awaiting review',
    NEW_VERSION_AWAITING_REVIEW: 'New version — awaiting review',
    DECOMMISSIONED: 'Decommissioned',
} as const;

export const OBLIGATION_STATUSES_KEYS = mapObjectKeysToValues(OBLIGATION_STATUSES);

/**
 * Statuses a user can manually set via the UI or API. Excludes system-managed statuses like
 * NEW_VERSION_AWAITING_REVIEW, which is a sentinel set only by the version-push job on
 * close-and-insert — allowing it via create/update/bulkUpdate would bypass the versioning
 * semantics the Obligation Versioning epic (CUR-2478) depends on.
 */
export const USER_SETTABLE_OBLIGATION_STATUS_KEYS = [
    OBLIGATION_STATUSES_KEYS.DRAFT,
    OBLIGATION_STATUSES_KEYS.AWAITING_REVIEW,
    OBLIGATION_STATUSES_KEYS.PUBLISHED,
    OBLIGATION_STATUSES_KEYS.DECOMMISSIONED,
] as const;

export type UserSettableObligationStatus = (typeof USER_SETTABLE_OBLIGATION_STATUS_KEYS)[number];

export const CURIUM_OBLIGATION_PREFIX = 'CUR-';
